<template>
  <div
    class="bg-black-transparent absolute w-full h-full backdrop-filter backdrop-blur-sm top-0 left-0 flex items-center justify-center">
    <div class="bg-white classen__rounded w-9/10 1.5xl:w-4/10 h-auto px-5 py-5 pb-10">
      <div class="w-full text-right">
        <div @click="$emit('close')" class="cursor-pointer text-gray-50 text-3xl"><i
          class="fas fa-times"></i></div>
      </div>
      <div v-if="state === 0">
        <c-loader :inline="true"/>
        <p class="text-center title text-2xl py-5 ">{{ getTranslation('generatingLink') }}</p>
      </div>
      <div v-if="state === 1" class="flex items-center flex-col">
        <p class="text-center title text-2xl mb-10 ">{{
            getTranslation('generatingLinkSuccess')
          }}</p>
        <p class="mb-5">{{ getTranslation('currentSelection') }}: {{ selection.name }}</p>
        <div class="classen__rounded_full bg-classen__secondary w-9/10 flex">
          <div class="linkText overflow-hidden overflow-ellipsis">
            <a :href="fullLink" target="_blank">{{ fullLink }}</a>
          </div>
          <div @click="copyToClipboard(fullLink)"
               class="copyIcon bg-classen__primary cursor-pointer flex items-center justify-center text-white ">
            <img src="../../../assets/icons/copy.svg" alt="copy" class="h-6/10">
          </div>
        </div>
      </div>
      <div v-if="state === 2">
        <p class="text-center title text-2xl py-5 ">{{ getTranslation('generatingLinkFailed') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import getTranslation from "../../../mixins/getTranslation";
import Loader from "../../Loader";
import copyToClipboard from "../../../mixins/copyToClipboard";

export default {
  name: "GenerateLink",

  mixins: [getTranslation, copyToClipboard],

  components: {
    'c-loader': Loader,
  },

  props: {
    selection: {required: true}
  },

  data() {
    return {
      state: 1,
      baseUrl: '',
      link: 'test'
    }
  },

  created() {
    this.baseUrl = process.env.VUE_APP_URL
    this.$dashboardStore.dispatch('generateLink', this.selection.id)
      .then((res) => {
        this.state = 1;
        this.link = res.id
      })
      .catch(() => {
        this.state = 3;
      })
  },

  destroyed() {

  },

  computed: {
    fullLink() {
      return `${this.baseUrl}/#/selection/${this.link}`
    }
  },

  watch: {},

  methods: {}
}
</script>

<style scoped>
.copyIcon {
  width: 65px;
  border-radius: 0 25px 25px 0;
}

.linkText {
  width: calc(100% - 65px);
}
</style>
